module.exports = __webpack_public_path__ + "img/combo_course_188_top.e483b207.png";